






















import { Component, Vue, Prop } from 'vue-property-decorator';

import { TeamInterface } from '@/interfaces/interfaces';
import TeamCaptain from '@/components/common/TeamCaptain.vue';
import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';

@Component({
  components: { TeamCaptain, TeamLogo }
})
export default class Team extends Vue {
  @Prop() public team!: TeamInterface;

  get customStyles() {
    return this.team.logo
      ? {
          color: this.team.logo.color,
          backgroundColor: this.team.logo.backgroundColor
        }
      : {};
  }
}
